/* MI: Keep the carousel count in sync with Ajax recommendations and section swaps. */
document.addEventListener('alpine:init', () => {
  Alpine.data('miCartCarousel', () => {
    let scroller;
    let mutationObserver;
    let resizeObserver;
    let refresh;
    let resize;
    let disposed = false;

    return {
      i: 1,
      n: 0,
      atStart: true,
      atEnd: false,
      width: window.innerWidth,
      cart_upsell_show: true,
      init() {
        this.cart_upsell_show = this.width >= 1024 || localStorage.getItem('cart_upsell_show') !== 'false';
        this.$nextTick(() => {
          if (disposed) return;
          scroller = this.$refs.scroller;
          refresh = () => this.refresh();
          resize = () => {
            this.width = window.innerWidth;
            if (this.width >= 1024) this.cart_upsell_show = true;
            refresh();
          };
          mutationObserver = new MutationObserver(refresh);
          mutationObserver.observe(scroller, { childList: true });
          resizeObserver = new ResizeObserver(refresh);
          resizeObserver.observe(scroller);
          scroller.addEventListener('scroll', refresh, { passive: true });
          window.addEventListener('resize', resize);
          refresh();
        });
      },
      refresh() {
        const cards = Array.from(scroller.children).filter(el => el.classList.contains('mi-upsell-card'));
        this.n = cards.length;
        this.i = 1;
        if (!this.n || !scroller.clientWidth) return;

        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        this.atStart = Math.abs(scroller.scrollLeft) <= 1;
        this.atEnd = maxScroll <= 1 || Math.abs(scroller.scrollLeft) >= maxScroll - 1;
        if (maxScroll > 1 && Math.abs(scroller.scrollLeft) >= maxScroll - 1) {
          this.i = this.n;
          return;
        }
        const rtl = getComputedStyle(scroller).direction === 'rtl';
        const edge = rtl ? 'right' : 'left';
        const start = scroller.getBoundingClientRect()[edge];
        let nearest = Infinity;
        cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect()[edge] - start);
          if (distance < nearest) {
            nearest = distance;
            this.i = index + 1;
          }
        });
      },
      /* Ohne Touch laesst sich ein overflow-x-Container mit der Maus nicht
         bewegen - deshalb auf dem Desktop zwei Pfeile. */
      step() {
        const cards = Array.from(scroller.children).filter(el => el.classList.contains('mi-upsell-card'));
        if (cards.length < 2) return cards.length ? cards[0].offsetWidth : scroller.clientWidth;
        return Math.abs(cards[1].offsetLeft - cards[0].offsetLeft) || cards[0].offsetWidth;
      },
      prev() { scroller.scrollBy({ left: -this.step(), behavior: 'smooth' }); },
      next() { scroller.scrollBy({ left:  this.step(), behavior: 'smooth' }); },
      toggleCartUpsell() {
        if (this.width >= 1024) return;
        this.cart_upsell_show = !this.cart_upsell_show;
        localStorage.setItem('cart_upsell_show', JSON.stringify(this.cart_upsell_show));
        this.$nextTick(() => this.refresh());
      },
      destroy() {
        disposed = true;
        mutationObserver?.disconnect();
        resizeObserver?.disconnect();
        scroller?.removeEventListener('scroll', refresh);
        window.removeEventListener('resize', resize);
      }
    };
  });
});
